<tabset class="nav nav-tabs admin-tab cs-primary-tabs cs-file-upload-primary-tabs" #fileUploadTabs>
    <tab autofocus class="padding0" id="file-upload" [active]="activeTab === 1"
        heading="{{'fileuploads.File Upload' |translate |translateKey}}" [removable]="false">
        <div class="container">
            <ng-container *ngTemplateOutlet="fileUpload">
            </ng-container>
        </div>
    </tab>
</tabset>

<ng-template #fileUpload>
    <div class="row padding0">
        <div id="file-uploads-container" class="col-md-6">
            <div *ngIf="fileUploadsForm">
                <form [formGroup]="fileUploadsForm">
                    <div class="row no-margin">
                        <div class="col-md-10 col-xs-5 padding0">
                            <label for="category" class="control-label col-xs-3 padding0">{{'fileuploads.Category'
                                | translate | translateKey }}</label>
                            <div class="col-xs-9 floating-input">
                                <select autofocus id="autofocus-modal-element" formControlName="category"
                                    class="form-control" (change)="changeCategory($event.target.value)">
                                    <option value="" [selected]="true" disabled>--{{'fileuploads.Select'| translate |
                                        translateKey }}--
                                    </option>
                                    <option *ngFor="let category of categories" [value]="category.id">
                                        {{category.categoryName}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="categories && categories.length > 0 && !categoryId; else permission_update" class="row no-margin select-info">
                        {{'fileuploads.Please select category to proceed further' | translate | translateKey }}
                    </div>
                    <ng-template #permission_update>
                        <div class="row no-margin select-info" *ngIf="!categoryId">
                            {{'fileuploads.You do not have access for category to proceed further' | translate | translateKey }}
                        </div>
                    </ng-template>
                    <div class="row no-margin">
                        <div class="col-md-10 col-xs-5 padding0"
                            *ngIf="(categoryIdentifier === categoryPermissions[1].identifier)">
                            <label for="template" class="control-label col-xs-3 padding0">{{'fileuploads.Template'
                                | translate | translateKey }}</label>
                            <div class="col-xs-9 floating-input">
                                <select class="form-control" formControlName="template"
                                    (change)="changeTemplate($event.target.value)">
                                    <option value="" [selected]="true" disabled>--{{'fileuploads.Select'| translate |
                                        translateKey }}--
                                    </option>
                                    <option *ngFor="let template of templates" [value]="template.id">
                                        {{template.templateName}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row no-margin">
                        <div class="col-md-10 col-xs-5 padding0" *ngIf="(categoryIdentifier === categoryPermissions[1].identifier)">
                            <label for="operatingCountry" class="control-label col-xs-3 padding0">{{'fileuploads.Operating Country'
                                | translate | translateKey }}</label>
                            <div class="col-xs-9 floating-input">
                                <select formControlName="operatingCountry"
                                    class="form-control" (change)="operatingCountryChange($event.target.value, true)">
                                    <option value="" [selected]="true" disabled>--{{'fileuploads.Select'| translate |
                                        translateKey }}--
                                    </option>
                                    <option *ngFor="let country of countries | orderBy:'name'" [value]="country.id">
                                        {{country.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="block-container" *ngIf="categoryIdentifier === categoryPermissions[0].identifier">
                <app-bonus-reissue-tickets></app-bonus-reissue-tickets>
            </div>
            <div class="block-container" *ngIf="categoryIdentifier === categoryPermissions[1].identifier">
                <app-recognition-upload [isValidForm]="fileUploadsForm.valid" [categoryName]="categoryName"
                  [categoryIdentifier]="categoryIdentifier" [operatingCountryID]="operatingCountry" [templateInfo]="templateInfo"></app-recognition-upload>
            </div>
            <div class="block-container" *ngIf="categoryIdentifier === categoryPermissions[2].identifier">
                <app-upload-japan-country-data [isFileUpload] ="true"></app-upload-japan-country-data>
            </div>
        </div>
        <div class="col-md-6 activity-logs-container">
            <div class="activity-log-label">
                {{'fileuploads.Activity Logs' | translate | translateKey }}
            </div>
            <div>
                <ul class="list-group" *ngIf="activityLogs && activityLogs.length > 0">
                    <li href="#" class="list-group-item" *ngFor="let log of activityLogs;">
                            {{log.templateName}}
                        <strong [class]="log.jobStatus?.toLowerCase()">({{log.jobStatus | titlecase}})</strong>
                        {{'fileuploads.initiated by' | translate | translateKey }} 
                          {{log.modifiedBy}} {{'fileuploads.on' | translate | translateKey
                        }}
                        {{log.modifiedDate | date: 'dd-MMM-yyyy hh:mm aa'}}
                    </li>
                </ul>
                <div class="activity-log-not-found text-center" *ngIf="activityLogs && activityLogs.length === 0">
                    <strong>{{'fileuploads.No Log(s) Found' | translate | translateKey }}</strong>
                </div>
            </div>
        </div>
    </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/file-uploads/file-uploads.component.html